import React, { useRef } from 'react';
import useRiskGauge, { getLabels } from '../../../../helpers/useRiskGauge';
import styled from 'styled-components';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 6px;
  
  label {
    margin-bottom: 0px;
    font-weight: 500;
  }

  .risk-score-container {
    margin-bottom: 10px;
    height: 140px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const RiskScore = ({
  score = {
    totalRisks: 0,
    score: 0,
    risksWithScore: 0,
  },
  t = (s) => s,
  showLabel = true,
  showLabelInScore = false,
}) => {
  const container = useRef();

  const {
    color,
    roundScore,
  } = useRiskGauge({ score, container, showLabel, showLabelInScore, t });

  return (
    <Style>
      <div
        ref={container}
        className="risk-score-container"
      />
      {showLabel && (
        <>
          <label>
            <strong>
              {score.risksWithScore}/{score.totalRisks}
            </strong>
            {' '}
            {t('Risk types assessed')}
          </label>
          <label>
            {t('Aggregte Risk')}:
            {' '}
            <strong style={{ color }}>{getLabels(roundScore, t)}</strong>
          </label>
        </>
      )}
    </Style>
  );
};

export default RiskScore;
